export const PROGRAM_SLUGS: Record<string, string> = {
  'Бэлтгэл бүлэг': 'prep-class',
  'Ерөнхий эрдэм': 'general-class',
  'Хөдөлмөр зуслан': 'summer-camp',
  'Дугуйлан секц': 'club-info',
};
